/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var rpc_admin_categories_pb = require('../../rpc/admin/categories_pb.js');
goog.object.extend(proto, rpc_admin_categories_pb);
var rpc_admin_countries_pb = require('../../rpc/admin/countries_pb.js');
goog.object.extend(proto, rpc_admin_countries_pb);
var rpc_admin_image_pb = require('../../rpc/admin/image_pb.js');
goog.object.extend(proto, rpc_admin_image_pb);
var rpc_admin_manufacturers_pb = require('../../rpc/admin/manufacturers_pb.js');
goog.object.extend(proto, rpc_admin_manufacturers_pb);
var rpc_admin_suppliers_pb = require('../../rpc/admin/suppliers_pb.js');
goog.object.extend(proto, rpc_admin_suppliers_pb);
var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
goog.exportSymbol('proto.admin.ChannelType', null, global);
goog.exportSymbol('proto.admin.ChannelTypeDescriptor', null, global);
goog.exportSymbol('proto.admin.DeleteProductRequest', null, global);
goog.exportSymbol('proto.admin.GenerateProductIdRequest', null, global);
goog.exportSymbol('proto.admin.GenerateProductIdResponse', null, global);
goog.exportSymbol('proto.admin.GetProductRequest', null, global);
goog.exportSymbol('proto.admin.GetProductResponse', null, global);
goog.exportSymbol('proto.admin.Product', null, global);
goog.exportSymbol('proto.admin.Product.Variant', null, global);
goog.exportSymbol('proto.admin.Product.Variant.AttributeValuePair', null, global);
goog.exportSymbol('proto.admin.Product.Variant.AttributeValuePair.ColorPicker', null, global);
goog.exportSymbol('proto.admin.Product.Variant.Channel', null, global);
goog.exportSymbol('proto.admin.Product.Variant.SupplierInventory', null, global);
goog.exportSymbol('proto.admin.ProductStatus', null, global);
goog.exportSymbol('proto.admin.ProductStatusDescriptor', null, global);
goog.exportSymbol('proto.admin.Restriction', null, global);
goog.exportSymbol('proto.admin.RestrictionDescriptor', null, global);
goog.exportSymbol('proto.admin.SaveProductRequest', null, global);
goog.exportSymbol('proto.admin.Shipping', null, global);
goog.exportSymbol('proto.admin.ShippingDescriptor', null, global);
goog.exportSymbol('proto.admin.UploadProductImageRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ProductStatusDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.ProductStatusDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ProductStatusDescriptor.displayName = 'proto.admin.ProductStatusDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ShippingDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.ShippingDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ShippingDescriptor.displayName = 'proto.admin.ShippingDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.RestrictionDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.RestrictionDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.RestrictionDescriptor.displayName = 'proto.admin.RestrictionDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.ChannelTypeDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.ChannelTypeDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.ChannelTypeDescriptor.displayName = 'proto.admin.ChannelTypeDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.Product.repeatedFields_, null);
};
goog.inherits(proto.admin.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.displayName = 'proto.admin.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product.Variant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.Product.Variant.repeatedFields_, null);
};
goog.inherits(proto.admin.Product.Variant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.Variant.displayName = 'proto.admin.Product.Variant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product.Variant.SupplierInventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.Product.Variant.SupplierInventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.Variant.SupplierInventory.displayName = 'proto.admin.Product.Variant.SupplierInventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product.Variant.AttributeValuePair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.Product.Variant.AttributeValuePair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.Variant.AttributeValuePair.displayName = 'proto.admin.Product.Variant.AttributeValuePair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.Product.Variant.AttributeValuePair.ColorPicker, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.Variant.AttributeValuePair.ColorPicker.displayName = 'proto.admin.Product.Variant.AttributeValuePair.ColorPicker';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.Product.Variant.Channel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.Product.Variant.Channel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.Product.Variant.Channel.displayName = 'proto.admin.Product.Variant.Channel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GetProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetProductRequest.displayName = 'proto.admin.GetProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.GetProductResponse.repeatedFields_, null);
};
goog.inherits(proto.admin.GetProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetProductResponse.displayName = 'proto.admin.GetProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.SaveProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.SaveProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.SaveProductRequest.displayName = 'proto.admin.SaveProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.DeleteProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.DeleteProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.DeleteProductRequest.displayName = 'proto.admin.DeleteProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.UploadProductImageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.UploadProductImageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.UploadProductImageRequest.displayName = 'proto.admin.UploadProductImageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GenerateProductIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GenerateProductIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GenerateProductIdRequest.displayName = 'proto.admin.GenerateProductIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GenerateProductIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.GenerateProductIdResponse.repeatedFields_, null);
};
goog.inherits(proto.admin.GenerateProductIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GenerateProductIdResponse.displayName = 'proto.admin.GenerateProductIdResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ProductStatusDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ProductStatusDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ProductStatusDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ProductStatusDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    productStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ProductStatusDescriptor}
 */
proto.admin.ProductStatusDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ProductStatusDescriptor;
  return proto.admin.ProductStatusDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ProductStatusDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ProductStatusDescriptor}
 */
proto.admin.ProductStatusDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.ProductStatus} */ (reader.readEnum());
      msg.setProductStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ProductStatusDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ProductStatusDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ProductStatusDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ProductStatusDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ProductStatus product_status = 1;
 * @return {!proto.admin.ProductStatus}
 */
proto.admin.ProductStatusDescriptor.prototype.getProductStatus = function() {
  return /** @type {!proto.admin.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.ProductStatus} value */
proto.admin.ProductStatusDescriptor.prototype.setProductStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.ProductStatusDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ProductStatusDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ShippingDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ShippingDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ShippingDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ShippingDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    shipping: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ShippingDescriptor}
 */
proto.admin.ShippingDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ShippingDescriptor;
  return proto.admin.ShippingDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ShippingDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ShippingDescriptor}
 */
proto.admin.ShippingDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Shipping} */ (reader.readEnum());
      msg.setShipping(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ShippingDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ShippingDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ShippingDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ShippingDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShipping();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Shipping shipping = 1;
 * @return {!proto.admin.Shipping}
 */
proto.admin.ShippingDescriptor.prototype.getShipping = function() {
  return /** @type {!proto.admin.Shipping} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Shipping} value */
proto.admin.ShippingDescriptor.prototype.setShipping = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.ShippingDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ShippingDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.RestrictionDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.RestrictionDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.RestrictionDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RestrictionDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    restriction: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.RestrictionDescriptor}
 */
proto.admin.RestrictionDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.RestrictionDescriptor;
  return proto.admin.RestrictionDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.RestrictionDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.RestrictionDescriptor}
 */
proto.admin.RestrictionDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Restriction} */ (reader.readEnum());
      msg.setRestriction(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.RestrictionDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.RestrictionDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.RestrictionDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RestrictionDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRestriction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Restriction restriction = 1;
 * @return {!proto.admin.Restriction}
 */
proto.admin.RestrictionDescriptor.prototype.getRestriction = function() {
  return /** @type {!proto.admin.Restriction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Restriction} value */
proto.admin.RestrictionDescriptor.prototype.setRestriction = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.RestrictionDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.RestrictionDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.ChannelTypeDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.ChannelTypeDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.ChannelTypeDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ChannelTypeDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.ChannelTypeDescriptor}
 */
proto.admin.ChannelTypeDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.ChannelTypeDescriptor;
  return proto.admin.ChannelTypeDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.ChannelTypeDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.ChannelTypeDescriptor}
 */
proto.admin.ChannelTypeDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.ChannelType} */ (reader.readEnum());
      msg.setChannelType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.ChannelTypeDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.ChannelTypeDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.ChannelTypeDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.ChannelTypeDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ChannelType channel_type = 1;
 * @return {!proto.admin.ChannelType}
 */
proto.admin.ChannelTypeDescriptor.prototype.getChannelType = function() {
  return /** @type {!proto.admin.ChannelType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.ChannelType} value */
proto.admin.ChannelTypeDescriptor.prototype.setChannelType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.ChannelTypeDescriptor.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.ChannelTypeDescriptor.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.Product.repeatedFields_ = [7,10,11,12,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    shortDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    longDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 6, 0),
    categoriesList: jspb.Message.getRepeatedField(msg, 7),
    metaName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    metaDescription: jspb.Message.getFieldWithDefault(msg, 9, ""),
    tagsList: jspb.Message.getRepeatedField(msg, 10),
    synonymsList: jspb.Message.getRepeatedField(msg, 11),
    keywordsList: jspb.Message.getRepeatedField(msg, 12),
    variantsList: jspb.Message.toObjectList(msg.getVariantsList(),
    proto.admin.Product.Variant.toObject, includeInstance),
    notes: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product}
 */
proto.admin.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product;
  return proto.admin.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product}
 */
proto.admin.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongDescription(value);
      break;
    case 6:
      var value = /** @type {!proto.admin.Manufacturer} */ (reader.readEnum());
      msg.setManufacturer(value);
      break;
    case 7:
      var value = /** @type {!Array<!proto.admin.Category>} */ (reader.readPackedEnum());
      msg.setCategoriesList(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaDescription(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addSynonyms(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addKeywords(value);
      break;
    case 13:
      var value = new proto.admin.Product.Variant;
      reader.readMessage(value,proto.admin.Product.Variant.deserializeBinaryFromReader);
      msg.addVariants(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getShortDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getManufacturer();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getMetaName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMetaDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getSynonymsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getVariantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.admin.Product.Variant.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.Product.Variant.repeatedFields_ = [8,17,18,19,20,21,22,27];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.Variant.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.Variant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product.Variant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.toObject = function(includeInstance, msg) {
  var f, obj = {
    sku: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    shortDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    longDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    manufacturerPartNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    barcode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    style: jspb.Message.getFieldWithDefault(msg, 7, ""),
    countryOfOriginList: jspb.Message.getRepeatedField(msg, 8),
    widthInches: +jspb.Message.getFieldWithDefault(msg, 9, 0.0),
    lengthInches: +jspb.Message.getFieldWithDefault(msg, 10, 0.0),
    heightInches: +jspb.Message.getFieldWithDefault(msg, 11, 0.0),
    weightOunces: +jspb.Message.getFieldWithDefault(msg, 12, 0.0),
    taxable: jspb.Message.getFieldWithDefault(msg, 13, false),
    slug: jspb.Message.getFieldWithDefault(msg, 14, ""),
    metaName: jspb.Message.getFieldWithDefault(msg, 15, ""),
    metaDescription: jspb.Message.getFieldWithDefault(msg, 16, ""),
    tagsList: jspb.Message.getRepeatedField(msg, 17),
    shippingList: jspb.Message.getRepeatedField(msg, 18),
    restrictionsList: jspb.Message.getRepeatedField(msg, 19),
    supplierInventoriesList: jspb.Message.toObjectList(msg.getSupplierInventoriesList(),
    proto.admin.Product.Variant.SupplierInventory.toObject, includeInstance),
    attributesList: jspb.Message.toObjectList(msg.getAttributesList(),
    proto.admin.Product.Variant.AttributeValuePair.toObject, includeInstance),
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    rpc_admin_image_pb.Image.toObject, includeInstance),
    notes: jspb.Message.getFieldWithDefault(msg, 23, ""),
    mapp: jspb.Message.getFieldWithDefault(msg, 24, 0),
    msrp: jspb.Message.getFieldWithDefault(msg, 25, 0),
    compareAt: jspb.Message.getFieldWithDefault(msg, 26, 0),
    channelsList: jspb.Message.toObjectList(msg.getChannelsList(),
    proto.admin.Product.Variant.Channel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product.Variant}
 */
proto.admin.Product.Variant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product.Variant;
  return proto.admin.Product.Variant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product.Variant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product.Variant}
 */
proto.admin.Product.Variant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSku(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerPartNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBarcode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStyle(value);
      break;
    case 8:
      var value = /** @type {!Array<!proto.admin.Country>} */ (reader.readPackedEnum());
      msg.setCountryOfOriginList(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidthInches(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLengthInches(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightInches(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeightOunces(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTaxable(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaName(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaDescription(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 18:
      var value = /** @type {!Array<!proto.admin.Shipping>} */ (reader.readPackedEnum());
      msg.setShippingList(value);
      break;
    case 19:
      var value = /** @type {!Array<!proto.admin.Restriction>} */ (reader.readPackedEnum());
      msg.setRestrictionsList(value);
      break;
    case 20:
      var value = new proto.admin.Product.Variant.SupplierInventory;
      reader.readMessage(value,proto.admin.Product.Variant.SupplierInventory.deserializeBinaryFromReader);
      msg.addSupplierInventories(value);
      break;
    case 21:
      var value = new proto.admin.Product.Variant.AttributeValuePair;
      reader.readMessage(value,proto.admin.Product.Variant.AttributeValuePair.deserializeBinaryFromReader);
      msg.addAttributes(value);
      break;
    case 22:
      var value = new rpc_admin_image_pb.Image;
      reader.readMessage(value,rpc_admin_image_pb.Image.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMapp(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMsrp(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompareAt(value);
      break;
    case 27:
      var value = new proto.admin.Product.Variant.Channel;
      reader.readMessage(value,proto.admin.Product.Variant.Channel.deserializeBinaryFromReader);
      msg.addChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.Variant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.Variant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product.Variant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSku();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShortDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLongDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManufacturerPartNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBarcode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStyle();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountryOfOriginList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getWidthInches();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getLengthInches();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getHeightInches();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getWeightOunces();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTaxable();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getMetaName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMetaDescription();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getShippingList();
  if (f.length > 0) {
    writer.writePackedEnum(
      18,
      f
    );
  }
  f = message.getRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      19,
      f
    );
  }
  f = message.getSupplierInventoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.admin.Product.Variant.SupplierInventory.serializeBinaryToWriter
    );
  }
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.admin.Product.Variant.AttributeValuePair.serializeBinaryToWriter
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      rpc_admin_image_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getMapp();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getMsrp();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getCompareAt();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      proto.admin.Product.Variant.Channel.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.Variant.SupplierInventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product.Variant.SupplierInventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.SupplierInventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    supplier: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sku: jspb.Message.getFieldWithDefault(msg, 2, ""),
    qoh: jspb.Message.getFieldWithDefault(msg, 3, 0),
    price: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product.Variant.SupplierInventory}
 */
proto.admin.Product.Variant.SupplierInventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product.Variant.SupplierInventory;
  return proto.admin.Product.Variant.SupplierInventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product.Variant.SupplierInventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product.Variant.SupplierInventory}
 */
proto.admin.Product.Variant.SupplierInventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Supplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQoh(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.Variant.SupplierInventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product.Variant.SupplierInventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.SupplierInventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQoh();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional Supplier supplier = 1;
 * @return {!proto.admin.Supplier}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.getSupplier = function() {
  return /** @type {!proto.admin.Supplier} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Supplier} value */
proto.admin.Product.Variant.SupplierInventory.prototype.setSupplier = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sku = 2;
 * @return {string}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.SupplierInventory.prototype.setSku = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 qoh = 3;
 * @return {number}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.getQoh = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.SupplierInventory.prototype.setQoh = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 price = 4;
 * @return {number}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.SupplierInventory.prototype.setPrice = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.admin.Product.Variant.SupplierInventory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.SupplierInventory.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.Variant.AttributeValuePair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product.Variant.AttributeValuePair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.AttributeValuePair.toObject = function(includeInstance, msg) {
  var f, obj = {
    attribute: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    picker: jspb.Message.getFieldWithDefault(msg, 3, 0),
    colorPicker: (f = msg.getColorPicker()) && proto.admin.Product.Variant.AttributeValuePair.ColorPicker.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product.Variant.AttributeValuePair}
 */
proto.admin.Product.Variant.AttributeValuePair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product.Variant.AttributeValuePair;
  return proto.admin.Product.Variant.AttributeValuePair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product.Variant.AttributeValuePair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product.Variant.AttributeValuePair}
 */
proto.admin.Product.Variant.AttributeValuePair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.Attribute} */ (reader.readEnum());
      msg.setAttribute(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto.admin.Picker} */ (reader.readEnum());
      msg.setPicker(value);
      break;
    case 4:
      var value = new proto.admin.Product.Variant.AttributeValuePair.ColorPicker;
      reader.readMessage(value,proto.admin.Product.Variant.AttributeValuePair.ColorPicker.deserializeBinaryFromReader);
      msg.setColorPicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.Variant.AttributeValuePair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product.Variant.AttributeValuePair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.AttributeValuePair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttribute();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPicker();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getColorPicker();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.admin.Product.Variant.AttributeValuePair.ColorPicker.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.Variant.AttributeValuePair.ColorPicker.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product.Variant.AttributeValuePair.ColorPicker} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.toObject = function(includeInstance, msg) {
  var f, obj = {
    hex: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product.Variant.AttributeValuePair.ColorPicker}
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product.Variant.AttributeValuePair.ColorPicker;
  return proto.admin.Product.Variant.AttributeValuePair.ColorPicker.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product.Variant.AttributeValuePair.ColorPicker} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product.Variant.AttributeValuePair.ColorPicker}
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.Variant.AttributeValuePair.ColorPicker.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product.Variant.AttributeValuePair.ColorPicker} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHex();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string hex = 1;
 * @return {string}
 */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.prototype.getHex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.AttributeValuePair.ColorPicker.prototype.setHex = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Attribute attribute = 1;
 * @return {!proto.admin.Attribute}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.getAttribute = function() {
  return /** @type {!proto.admin.Attribute} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.Attribute} value */
proto.admin.Product.Variant.AttributeValuePair.prototype.setAttribute = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.AttributeValuePair.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Picker picker = 3;
 * @return {!proto.admin.Picker}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.getPicker = function() {
  return /** @type {!proto.admin.Picker} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.admin.Picker} value */
proto.admin.Product.Variant.AttributeValuePair.prototype.setPicker = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ColorPicker color_picker = 4;
 * @return {?proto.admin.Product.Variant.AttributeValuePair.ColorPicker}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.getColorPicker = function() {
  return /** @type{?proto.admin.Product.Variant.AttributeValuePair.ColorPicker} */ (
    jspb.Message.getWrapperField(this, proto.admin.Product.Variant.AttributeValuePair.ColorPicker, 4));
};


/** @param {?proto.admin.Product.Variant.AttributeValuePair.ColorPicker|undefined} value */
proto.admin.Product.Variant.AttributeValuePair.prototype.setColorPicker = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.clearColorPicker = function() {
  this.setColorPicker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.Product.Variant.AttributeValuePair.prototype.hasColorPicker = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.Product.Variant.Channel.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.Product.Variant.Channel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.Product.Variant.Channel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.Channel.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    price: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.Product.Variant.Channel}
 */
proto.admin.Product.Variant.Channel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.Product.Variant.Channel;
  return proto.admin.Product.Variant.Channel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.Product.Variant.Channel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.Product.Variant.Channel}
 */
proto.admin.Product.Variant.Channel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admin.ChannelType} */ (reader.readEnum());
      msg.setChannelType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {!proto.admin.ProductStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.Product.Variant.Channel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.Product.Variant.Channel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.Product.Variant.Channel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.Product.Variant.Channel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional ChannelType channel_type = 1;
 * @return {!proto.admin.ChannelType}
 */
proto.admin.Product.Variant.Channel.prototype.getChannelType = function() {
  return /** @type {!proto.admin.ChannelType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.admin.ChannelType} value */
proto.admin.Product.Variant.Channel.prototype.setChannelType = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 price = 2;
 * @return {number}
 */
proto.admin.Product.Variant.Channel.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.Channel.prototype.setPrice = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ProductStatus status = 3;
 * @return {!proto.admin.ProductStatus}
 */
proto.admin.Product.Variant.Channel.prototype.getStatus = function() {
  return /** @type {!proto.admin.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.admin.ProductStatus} value */
proto.admin.Product.Variant.Channel.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 sku = 1;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getSku = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setSku = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string short_description = 3;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getShortDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setShortDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string long_description = 4;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getLongDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setLongDescription = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string manufacturer_part_number = 5;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getManufacturerPartNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setManufacturerPartNumber = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string barcode = 6;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getBarcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setBarcode = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string style = 7;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getStyle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setStyle = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Country country_of_origin = 8;
 * @return {!Array<!proto.admin.Country>}
 */
proto.admin.Product.Variant.prototype.getCountryOfOriginList = function() {
  return /** @type {!Array<!proto.admin.Country>} */ (jspb.Message.getRepeatedField(this, 8));
};


/** @param {!Array<!proto.admin.Country>} value */
proto.admin.Product.Variant.prototype.setCountryOfOriginList = function(value) {
  jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.admin.Country} value
 * @param {number=} opt_index
 */
proto.admin.Product.Variant.prototype.addCountryOfOrigin = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearCountryOfOriginList = function() {
  this.setCountryOfOriginList([]);
};


/**
 * optional double width_inches = 9;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getWidthInches = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 9, 0.0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setWidthInches = function(value) {
  jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double length_inches = 10;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getLengthInches = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 10, 0.0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setLengthInches = function(value) {
  jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double height_inches = 11;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getHeightInches = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 11, 0.0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setHeightInches = function(value) {
  jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double weight_ounces = 12;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getWeightOunces = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 12, 0.0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setWeightOunces = function(value) {
  jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional bool taxable = 13;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.Product.Variant.prototype.getTaxable = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 13, false));
};


/** @param {boolean} value */
proto.admin.Product.Variant.prototype.setTaxable = function(value) {
  jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string slug = 14;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setSlug = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string meta_name = 15;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getMetaName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setMetaName = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string meta_description = 16;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getMetaDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setMetaDescription = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * repeated string tags = 17;
 * @return {!Array<string>}
 */
proto.admin.Product.Variant.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/** @param {!Array<string>} value */
proto.admin.Product.Variant.prototype.setTagsList = function(value) {
  jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.Product.Variant.prototype.addTags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearTagsList = function() {
  this.setTagsList([]);
};


/**
 * repeated Shipping shipping = 18;
 * @return {!Array<!proto.admin.Shipping>}
 */
proto.admin.Product.Variant.prototype.getShippingList = function() {
  return /** @type {!Array<!proto.admin.Shipping>} */ (jspb.Message.getRepeatedField(this, 18));
};


/** @param {!Array<!proto.admin.Shipping>} value */
proto.admin.Product.Variant.prototype.setShippingList = function(value) {
  jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {!proto.admin.Shipping} value
 * @param {number=} opt_index
 */
proto.admin.Product.Variant.prototype.addShipping = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearShippingList = function() {
  this.setShippingList([]);
};


/**
 * repeated Restriction restrictions = 19;
 * @return {!Array<!proto.admin.Restriction>}
 */
proto.admin.Product.Variant.prototype.getRestrictionsList = function() {
  return /** @type {!Array<!proto.admin.Restriction>} */ (jspb.Message.getRepeatedField(this, 19));
};


/** @param {!Array<!proto.admin.Restriction>} value */
proto.admin.Product.Variant.prototype.setRestrictionsList = function(value) {
  jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {!proto.admin.Restriction} value
 * @param {number=} opt_index
 */
proto.admin.Product.Variant.prototype.addRestrictions = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearRestrictionsList = function() {
  this.setRestrictionsList([]);
};


/**
 * repeated SupplierInventory supplier_inventories = 20;
 * @return {!Array<!proto.admin.Product.Variant.SupplierInventory>}
 */
proto.admin.Product.Variant.prototype.getSupplierInventoriesList = function() {
  return /** @type{!Array<!proto.admin.Product.Variant.SupplierInventory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Product.Variant.SupplierInventory, 20));
};


/** @param {!Array<!proto.admin.Product.Variant.SupplierInventory>} value */
proto.admin.Product.Variant.prototype.setSupplierInventoriesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.admin.Product.Variant.SupplierInventory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Product.Variant.SupplierInventory}
 */
proto.admin.Product.Variant.prototype.addSupplierInventories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.admin.Product.Variant.SupplierInventory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearSupplierInventoriesList = function() {
  this.setSupplierInventoriesList([]);
};


/**
 * repeated AttributeValuePair attributes = 21;
 * @return {!Array<!proto.admin.Product.Variant.AttributeValuePair>}
 */
proto.admin.Product.Variant.prototype.getAttributesList = function() {
  return /** @type{!Array<!proto.admin.Product.Variant.AttributeValuePair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Product.Variant.AttributeValuePair, 21));
};


/** @param {!Array<!proto.admin.Product.Variant.AttributeValuePair>} value */
proto.admin.Product.Variant.prototype.setAttributesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.admin.Product.Variant.AttributeValuePair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Product.Variant.AttributeValuePair}
 */
proto.admin.Product.Variant.prototype.addAttributes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.admin.Product.Variant.AttributeValuePair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearAttributesList = function() {
  this.setAttributesList([]);
};


/**
 * repeated Image images = 22;
 * @return {!Array<!proto.admin.Image>}
 */
proto.admin.Product.Variant.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.admin.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_image_pb.Image, 22));
};


/** @param {!Array<!proto.admin.Image>} value */
proto.admin.Product.Variant.prototype.setImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.admin.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Image}
 */
proto.admin.Product.Variant.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.admin.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearImagesList = function() {
  this.setImagesList([]);
};


/**
 * optional string notes = 23;
 * @return {string}
 */
proto.admin.Product.Variant.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.admin.Product.Variant.prototype.setNotes = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional int64 mapp = 24;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getMapp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setMapp = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 msrp = 25;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getMsrp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setMsrp = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 compare_at = 26;
 * @return {number}
 */
proto.admin.Product.Variant.prototype.getCompareAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {number} value */
proto.admin.Product.Variant.prototype.setCompareAt = function(value) {
  jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * repeated Channel channels = 27;
 * @return {!Array<!proto.admin.Product.Variant.Channel>}
 */
proto.admin.Product.Variant.prototype.getChannelsList = function() {
  return /** @type{!Array<!proto.admin.Product.Variant.Channel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Product.Variant.Channel, 27));
};


/** @param {!Array<!proto.admin.Product.Variant.Channel>} value */
proto.admin.Product.Variant.prototype.setChannelsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.admin.Product.Variant.Channel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Product.Variant.Channel}
 */
proto.admin.Product.Variant.prototype.addChannels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.admin.Product.Variant.Channel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.Variant.prototype.clearChannelsList = function() {
  this.setChannelsList([]);
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.admin.Product.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.Product.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.admin.Product.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setSlug = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.admin.Product.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string short_description = 4;
 * @return {string}
 */
proto.admin.Product.prototype.getShortDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setShortDescription = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string long_description = 5;
 * @return {string}
 */
proto.admin.Product.prototype.getLongDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setLongDescription = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Manufacturer manufacturer = 6;
 * @return {!proto.admin.Manufacturer}
 */
proto.admin.Product.prototype.getManufacturer = function() {
  return /** @type {!proto.admin.Manufacturer} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.admin.Manufacturer} value */
proto.admin.Product.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated Category categories = 7;
 * @return {!Array<!proto.admin.Category>}
 */
proto.admin.Product.prototype.getCategoriesList = function() {
  return /** @type {!Array<!proto.admin.Category>} */ (jspb.Message.getRepeatedField(this, 7));
};


/** @param {!Array<!proto.admin.Category>} value */
proto.admin.Product.prototype.setCategoriesList = function(value) {
  jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.admin.Category} value
 * @param {number=} opt_index
 */
proto.admin.Product.prototype.addCategories = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.prototype.clearCategoriesList = function() {
  this.setCategoriesList([]);
};


/**
 * optional string meta_name = 8;
 * @return {string}
 */
proto.admin.Product.prototype.getMetaName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setMetaName = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string meta_description = 9;
 * @return {string}
 */
proto.admin.Product.prototype.getMetaDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setMetaDescription = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string tags = 10;
 * @return {!Array<string>}
 */
proto.admin.Product.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/** @param {!Array<string>} value */
proto.admin.Product.prototype.setTagsList = function(value) {
  jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.Product.prototype.addTags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.prototype.clearTagsList = function() {
  this.setTagsList([]);
};


/**
 * repeated string synonyms = 11;
 * @return {!Array<string>}
 */
proto.admin.Product.prototype.getSynonymsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/** @param {!Array<string>} value */
proto.admin.Product.prototype.setSynonymsList = function(value) {
  jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.Product.prototype.addSynonyms = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.prototype.clearSynonymsList = function() {
  this.setSynonymsList([]);
};


/**
 * repeated string keywords = 12;
 * @return {!Array<string>}
 */
proto.admin.Product.prototype.getKeywordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/** @param {!Array<string>} value */
proto.admin.Product.prototype.setKeywordsList = function(value) {
  jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.Product.prototype.addKeywords = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.prototype.clearKeywordsList = function() {
  this.setKeywordsList([]);
};


/**
 * repeated Variant variants = 13;
 * @return {!Array<!proto.admin.Product.Variant>}
 */
proto.admin.Product.prototype.getVariantsList = function() {
  return /** @type{!Array<!proto.admin.Product.Variant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.Product.Variant, 13));
};


/** @param {!Array<!proto.admin.Product.Variant>} value */
proto.admin.Product.prototype.setVariantsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.admin.Product.Variant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Product.Variant}
 */
proto.admin.Product.prototype.addVariants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.admin.Product.Variant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.Product.prototype.clearVariantsList = function() {
  this.setVariantsList([]);
};


/**
 * optional string notes = 14;
 * @return {string}
 */
proto.admin.Product.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.Product.prototype.setNotes = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetProductRequest}
 */
proto.admin.GetProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetProductRequest;
  return proto.admin.GetProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetProductRequest}
 */
proto.admin.GetProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.admin.GetProductRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.GetProductRequest.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.GetProductResponse.repeatedFields_ = [2,3,4,5,6,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: (f = msg.getProduct()) && proto.admin.Product.toObject(includeInstance, f),
    statusDescriptorsList: jspb.Message.toObjectList(msg.getStatusDescriptorsList(),
    proto.admin.ProductStatusDescriptor.toObject, includeInstance),
    shippingDescriptorsList: jspb.Message.toObjectList(msg.getShippingDescriptorsList(),
    proto.admin.ShippingDescriptor.toObject, includeInstance),
    restrictionDescriptorsList: jspb.Message.toObjectList(msg.getRestrictionDescriptorsList(),
    proto.admin.RestrictionDescriptor.toObject, includeInstance),
    channelTypeDescriptorsList: jspb.Message.toObjectList(msg.getChannelTypeDescriptorsList(),
    proto.admin.ChannelTypeDescriptor.toObject, includeInstance),
    supplierDescriptorsList: jspb.Message.toObjectList(msg.getSupplierDescriptorsList(),
    rpc_admin_suppliers_pb.SupplierDescriptor.toObject, includeInstance),
    categoryDescriptorsList: jspb.Message.toObjectList(msg.getCategoryDescriptorsList(),
    rpc_admin_categories_pb.CategoryDescriptor.toObject, includeInstance),
    manufacturerDescriptorsList: jspb.Message.toObjectList(msg.getManufacturerDescriptorsList(),
    rpc_admin_manufacturers_pb.ManufacturerDescriptor.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetProductResponse}
 */
proto.admin.GetProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetProductResponse;
  return proto.admin.GetProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetProductResponse}
 */
proto.admin.GetProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admin.Product;
      reader.readMessage(value,proto.admin.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 2:
      var value = new proto.admin.ProductStatusDescriptor;
      reader.readMessage(value,proto.admin.ProductStatusDescriptor.deserializeBinaryFromReader);
      msg.addStatusDescriptors(value);
      break;
    case 3:
      var value = new proto.admin.ShippingDescriptor;
      reader.readMessage(value,proto.admin.ShippingDescriptor.deserializeBinaryFromReader);
      msg.addShippingDescriptors(value);
      break;
    case 4:
      var value = new proto.admin.RestrictionDescriptor;
      reader.readMessage(value,proto.admin.RestrictionDescriptor.deserializeBinaryFromReader);
      msg.addRestrictionDescriptors(value);
      break;
    case 5:
      var value = new proto.admin.ChannelTypeDescriptor;
      reader.readMessage(value,proto.admin.ChannelTypeDescriptor.deserializeBinaryFromReader);
      msg.addChannelTypeDescriptors(value);
      break;
    case 6:
      var value = new rpc_admin_suppliers_pb.SupplierDescriptor;
      reader.readMessage(value,rpc_admin_suppliers_pb.SupplierDescriptor.deserializeBinaryFromReader);
      msg.addSupplierDescriptors(value);
      break;
    case 7:
      var value = new rpc_admin_categories_pb.CategoryDescriptor;
      reader.readMessage(value,rpc_admin_categories_pb.CategoryDescriptor.deserializeBinaryFromReader);
      msg.addCategoryDescriptors(value);
      break;
    case 8:
      var value = new rpc_admin_manufacturers_pb.ManufacturerDescriptor;
      reader.readMessage(value,rpc_admin_manufacturers_pb.ManufacturerDescriptor.deserializeBinaryFromReader);
      msg.addManufacturerDescriptors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admin.Product.serializeBinaryToWriter
    );
  }
  f = message.getStatusDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.admin.ProductStatusDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getShippingDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.admin.ShippingDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getRestrictionDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.admin.RestrictionDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getChannelTypeDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.admin.ChannelTypeDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getSupplierDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      rpc_admin_suppliers_pb.SupplierDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getCategoryDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      rpc_admin_categories_pb.CategoryDescriptor.serializeBinaryToWriter
    );
  }
  f = message.getManufacturerDescriptorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      rpc_admin_manufacturers_pb.ManufacturerDescriptor.serializeBinaryToWriter
    );
  }
};


/**
 * optional Product product = 1;
 * @return {?proto.admin.Product}
 */
proto.admin.GetProductResponse.prototype.getProduct = function() {
  return /** @type{?proto.admin.Product} */ (
    jspb.Message.getWrapperField(this, proto.admin.Product, 1));
};


/** @param {?proto.admin.Product|undefined} value */
proto.admin.GetProductResponse.prototype.setProduct = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.GetProductResponse.prototype.clearProduct = function() {
  this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.GetProductResponse.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ProductStatusDescriptor status_descriptors = 2;
 * @return {!Array<!proto.admin.ProductStatusDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getStatusDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.ProductStatusDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.ProductStatusDescriptor, 2));
};


/** @param {!Array<!proto.admin.ProductStatusDescriptor>} value */
proto.admin.GetProductResponse.prototype.setStatusDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.admin.ProductStatusDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.ProductStatusDescriptor}
 */
proto.admin.GetProductResponse.prototype.addStatusDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.admin.ProductStatusDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearStatusDescriptorsList = function() {
  this.setStatusDescriptorsList([]);
};


/**
 * repeated ShippingDescriptor shipping_descriptors = 3;
 * @return {!Array<!proto.admin.ShippingDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getShippingDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.ShippingDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.ShippingDescriptor, 3));
};


/** @param {!Array<!proto.admin.ShippingDescriptor>} value */
proto.admin.GetProductResponse.prototype.setShippingDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.admin.ShippingDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.ShippingDescriptor}
 */
proto.admin.GetProductResponse.prototype.addShippingDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.admin.ShippingDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearShippingDescriptorsList = function() {
  this.setShippingDescriptorsList([]);
};


/**
 * repeated RestrictionDescriptor restriction_descriptors = 4;
 * @return {!Array<!proto.admin.RestrictionDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getRestrictionDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.RestrictionDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.RestrictionDescriptor, 4));
};


/** @param {!Array<!proto.admin.RestrictionDescriptor>} value */
proto.admin.GetProductResponse.prototype.setRestrictionDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.admin.RestrictionDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.RestrictionDescriptor}
 */
proto.admin.GetProductResponse.prototype.addRestrictionDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.admin.RestrictionDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearRestrictionDescriptorsList = function() {
  this.setRestrictionDescriptorsList([]);
};


/**
 * repeated ChannelTypeDescriptor channel_type_descriptors = 5;
 * @return {!Array<!proto.admin.ChannelTypeDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getChannelTypeDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.ChannelTypeDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.ChannelTypeDescriptor, 5));
};


/** @param {!Array<!proto.admin.ChannelTypeDescriptor>} value */
proto.admin.GetProductResponse.prototype.setChannelTypeDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.admin.ChannelTypeDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.ChannelTypeDescriptor}
 */
proto.admin.GetProductResponse.prototype.addChannelTypeDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.admin.ChannelTypeDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearChannelTypeDescriptorsList = function() {
  this.setChannelTypeDescriptorsList([]);
};


/**
 * repeated SupplierDescriptor supplier_descriptors = 6;
 * @return {!Array<!proto.admin.SupplierDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getSupplierDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.SupplierDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_suppliers_pb.SupplierDescriptor, 6));
};


/** @param {!Array<!proto.admin.SupplierDescriptor>} value */
proto.admin.GetProductResponse.prototype.setSupplierDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.admin.SupplierDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.SupplierDescriptor}
 */
proto.admin.GetProductResponse.prototype.addSupplierDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.admin.SupplierDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearSupplierDescriptorsList = function() {
  this.setSupplierDescriptorsList([]);
};


/**
 * repeated CategoryDescriptor category_descriptors = 7;
 * @return {!Array<!proto.admin.CategoryDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getCategoryDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.CategoryDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_categories_pb.CategoryDescriptor, 7));
};


/** @param {!Array<!proto.admin.CategoryDescriptor>} value */
proto.admin.GetProductResponse.prototype.setCategoryDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.admin.CategoryDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.CategoryDescriptor}
 */
proto.admin.GetProductResponse.prototype.addCategoryDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.admin.CategoryDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearCategoryDescriptorsList = function() {
  this.setCategoryDescriptorsList([]);
};


/**
 * repeated ManufacturerDescriptor manufacturer_descriptors = 8;
 * @return {!Array<!proto.admin.ManufacturerDescriptor>}
 */
proto.admin.GetProductResponse.prototype.getManufacturerDescriptorsList = function() {
  return /** @type{!Array<!proto.admin.ManufacturerDescriptor>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_manufacturers_pb.ManufacturerDescriptor, 8));
};


/** @param {!Array<!proto.admin.ManufacturerDescriptor>} value */
proto.admin.GetProductResponse.prototype.setManufacturerDescriptorsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.admin.ManufacturerDescriptor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.ManufacturerDescriptor}
 */
proto.admin.GetProductResponse.prototype.addManufacturerDescriptors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.admin.ManufacturerDescriptor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GetProductResponse.prototype.clearManufacturerDescriptorsList = function() {
  this.setManufacturerDescriptorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.SaveProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.SaveProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.SaveProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SaveProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: (f = msg.getProduct()) && proto.admin.Product.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.SaveProductRequest}
 */
proto.admin.SaveProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.SaveProductRequest;
  return proto.admin.SaveProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.SaveProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.SaveProductRequest}
 */
proto.admin.SaveProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admin.Product;
      reader.readMessage(value,proto.admin.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.SaveProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.SaveProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.SaveProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.SaveProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admin.Product.serializeBinaryToWriter
    );
  }
};


/**
 * optional Product product = 1;
 * @return {?proto.admin.Product}
 */
proto.admin.SaveProductRequest.prototype.getProduct = function() {
  return /** @type{?proto.admin.Product} */ (
    jspb.Message.getWrapperField(this, proto.admin.Product, 1));
};


/** @param {?proto.admin.Product|undefined} value */
proto.admin.SaveProductRequest.prototype.setProduct = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.admin.SaveProductRequest.prototype.clearProduct = function() {
  this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admin.SaveProductRequest.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.DeleteProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.DeleteProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.DeleteProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.DeleteProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.DeleteProductRequest}
 */
proto.admin.DeleteProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.DeleteProductRequest;
  return proto.admin.DeleteProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.DeleteProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.DeleteProductRequest}
 */
proto.admin.DeleteProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.DeleteProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.DeleteProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.DeleteProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.DeleteProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.admin.DeleteProductRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.DeleteProductRequest.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.UploadProductImageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.UploadProductImageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.UploadProductImageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.UploadProductImageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    image: msg.getImage_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.UploadProductImageRequest}
 */
proto.admin.UploadProductImageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.UploadProductImageRequest;
  return proto.admin.UploadProductImageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.UploadProductImageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.UploadProductImageRequest}
 */
proto.admin.UploadProductImageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.UploadProductImageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.UploadProductImageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.UploadProductImageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.UploadProductImageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes image = 1;
 * @return {string}
 */
proto.admin.UploadProductImageRequest.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes image = 1;
 * This is a type-conversion wrapper around `getImage()`
 * @return {string}
 */
proto.admin.UploadProductImageRequest.prototype.getImage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImage()));
};


/**
 * optional bytes image = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImage()`
 * @return {!Uint8Array}
 */
proto.admin.UploadProductImageRequest.prototype.getImage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImage()));
};


/** @param {!(string|Uint8Array)} value */
proto.admin.UploadProductImageRequest.prototype.setImage = function(value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GenerateProductIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GenerateProductIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GenerateProductIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GenerateProductIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GenerateProductIdRequest}
 */
proto.admin.GenerateProductIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GenerateProductIdRequest;
  return proto.admin.GenerateProductIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GenerateProductIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GenerateProductIdRequest}
 */
proto.admin.GenerateProductIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GenerateProductIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GenerateProductIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GenerateProductIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GenerateProductIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 count = 1;
 * @return {number}
 */
proto.admin.GenerateProductIdRequest.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.admin.GenerateProductIdRequest.prototype.setCount = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.GenerateProductIdResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GenerateProductIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GenerateProductIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GenerateProductIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GenerateProductIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GenerateProductIdResponse}
 */
proto.admin.GenerateProductIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GenerateProductIdResponse;
  return proto.admin.GenerateProductIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GenerateProductIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GenerateProductIdResponse}
 */
proto.admin.GenerateProductIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GenerateProductIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GenerateProductIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GenerateProductIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GenerateProductIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 ids = 1;
 * @return {!Array<number>}
 */
proto.admin.GenerateProductIdResponse.prototype.getIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.admin.GenerateProductIdResponse.prototype.setIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.admin.GenerateProductIdResponse.prototype.addIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.GenerateProductIdResponse.prototype.clearIdsList = function() {
  this.setIdsList([]);
};


/**
 * @enum {number}
 */
proto.admin.ProductStatus = {
  PRODUCT_STATUS_UNKNOWN: 0,
  AVAILABLE: 1,
  HIDDEN: 2,
  DISABLED: 3,
  COMING_SOON: 4,
  UNREVIEWED: 5
};

/**
 * @enum {number}
 */
proto.admin.Shipping = {
  SHIPPING_UNKNOWN: 0,
  REQUIRES_FFL: 1,
  REQUIRES_FFL_WITH_SOT: 2,
  REQUIRES_FFL_OVERNIGHT: 3,
  GROUND_ONLY: 4
};

/**
 * @enum {number}
 */
proto.admin.Restriction = {
  RESTRICTION_UNKNOWN: 0,
  FIVE_ROUND_OR_MORE_MAGAZINE: 1,
  TEN_ROUND_OR_MORE_MAGAZINE: 2,
  FIFTEEN_ROUND_OR_MORE_MAGAZINE: 3,
  TWENTY_ROUND_OR_MORE_MAGAZINE: 4,
  TWENTY_FIVE_ROUND_OR_MORE_MAGAZINE: 5,
  THIRTY_ROUND_OR_MORE_MAGAZINE: 6,
  ASSAULT_WEAPON: 7,
  CA_ASSAULT_WEAPON: 8,
  SILENCER: 9,
  SHORT_BARRELED_RIFLE: 10,
  SHORT_BARRELED_SHOTGUN: 11,
  MACHINE_GUN: 12,
  GRENADE_LAUNCHER: 13
};

/**
 * @enum {number}
 */
proto.admin.ChannelType = {
  CHANNEL_UNKNOWN: 0,
  RETAIL: 1,
  HAWK_AMERICAN: 2,
  SHOOTING_ON_SALE: 3
};

goog.object.extend(exports, proto.admin);
